import './Checkbox.less'
import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { Checkbox as AntCheckbox } from 'antd'


export default class Checkbox extends PureComponent {
  render() {
    const { className } = this.props
    const CheckboxClassName = classNames(className, 'pan-checkbox')
    const CheckboxProps = {
      className: CheckboxClassName
    }
    return <AntCheckbox {...this.props} {...CheckboxProps} />
  }
}
Checkbox.propTypes = {
  className: PropTypes.string
}

Checkbox.AntCheckbox = AntCheckbox
Checkbox.Group = AntCheckbox.Group
